import styled from 'styled-components';

export const ScOfferSubtitle = styled.p`
  margin: 0;
  font-family: inherit;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 1px;
  line-height: normal;
  text-align: center;
  text-transform: uppercase;
  color: #cdb2de;

  span {
    display: block;
    font-weight: 700;
    color: #fff;
  }
`;
